import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Box,
    Paper,
    styled
} from "@mui/material";
import IProfile from "../../../models/profile";
import profileService from "../../../services/profile/ProfileService";
import AddProfile from "./AddProfile";
import IEditProfileRequest from "../../../models/requests/profile/editProfileRequest";

const TaskWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginTop: "1em",
}));

interface IProfileDetail {
    name: string;
    description: string;
    id: number;
    tasks: number[];
    companyId: number;
}
const ProfileEditPage = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isFormSending, setIsFormSending] = useState(false);
    const [selectedTasksIds, setSelectedTasksIds] = useState<number[]>([]);
    const {
        id,
        name,
        description,
        tasks,
        companyId,
    }: IProfileDetail = location.state;

    const [profile, setProfile] = useState<IProfile>({
        description,
        name,
        companyId,
        createDate: new Date(),
        id,
        tasks,
        updateDate: new Date(),
    });
    const [cachedProfile, setCachedProfile] = useState<IProfile>({
        description,
        name,
        companyId,
        createDate: new Date(),
        id,
        tasks,
        updateDate: new Date(),
    });
    const [isProfileChanged, setIsProfileChanged] = useState(false);

    useEffect(() => {
        profileService.GetTasksProfileId(id).then((tasks) => {
            if (!tasks) return;
            setSelectedTasksIds(tasks.map((t) => t.id));
            setProfile((prevProfile) => ({
                ...prevProfile,
                tasks: tasks.map(t => t.id),
            }));
            setCachedProfile((prevProfile) => ({
                ...prevProfile,
                tasks: tasks.map(t => t.id),
            }));
        });
    }, []);

    useEffect(() => {
        setIsProfileChanged(false);

        if (JSON.stringify(profile) !== JSON.stringify(cachedProfile)) {
            setIsProfileChanged(true);
        }

    }, [profile, cachedProfile]);

    const onEditProfile = () => {
        setIsFormSending(true);
        const editProfile: IEditProfileRequest = {
            id: profile.id,
            companyId: profile.companyId,
            description: profile.description,
            name: profile.name,
            tasksIds: profile.tasks,
            createDate: profile.createDate,
            updateDate: profile.updateDate,
        };
        profileService.PutProfile(editProfile).then(() => {
            setIsFormSending(false);
            navigate("..");
        });
        setCachedProfile(profile);
    };
    const onInputChange = <K extends keyof IProfile>(
        field: K,
        value: IProfile[K]
    ) => {
        setProfile((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    return (
        <Box component={Paper} sx={{ width: "100%" }}>
            <TaskWrapper>
                {selectedTasksIds && (
                    <AddProfile
                        profile={profile}
                        handleProfile={onEditProfile}
                        isCreation={false}
                        isFormSending={isFormSending}
                        onInputChange={onInputChange}
                        isProfileChanged={isProfileChanged}
                        selectedTasksIds={selectedTasksIds}
                    />
                )}
            </TaskWrapper>
        </Box>
    );
};

export default ProfileEditPage;
